import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const StopwatchOff = (props: Icon): React.ReactElement =>
  props.variant === "line" ? (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M6.666 10.515c.342.135.51.522.376.865a5.308 5.308 0 00-.375 1.953A5.333 5.333 0 0012 18.667c.671 0 1.329-.129 1.953-.375a.667.667 0 01.49 1.24A6.64 6.64 0 0112 20a6.667 6.667 0 01-6.667-6.667c0-.84.161-1.664.468-2.442a.667.667 0 01.865-.376zM5.076 4.14l.062.055 14.667 14.667a.667.667 0 01-.88.998l-.063-.055L4.195 5.138a.667.667 0 01.88-.998zm6.979 2.529a6.644 6.644 0 014.518 1.816l.956-.956a.667.667 0 01.998.88l-.056.062-1.023 1.023a6.634 6.634 0 011.216 3.784.667.667 0 01-1.333.01 5.33 5.33 0 00-5.287-5.286.667.667 0 01.01-1.333zM14.667 4a.667.667 0 01.077 1.329l-.077.004H9.333a.667.667 0 01-.077-1.329L9.333 4h5.334z"
          id="stopwatchoff_line_a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="stopwatchoff_line_b" fill="#fff">
          <use xlinkHref="#stopwatchoff_line_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#stopwatchoff_line_a" />
        <g
          mask="url(#stopwatchoff_line_b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  ) : (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          d="M19.805 18.862l-2.099-2.099a6.627 6.627 0 00-.31-7.334l1.047-.93a.667.667 0 10-.886-.997l-1.048.931A6.636 6.636 0 0012 6.667a6.603 6.603 0 00-3.43.96L5.138 4.195a.666.666 0 10-.943.943l14.667 14.667a.665.665 0 00.943 0 .666.666 0 000-.943zM9.333 5.333h5.334c.366 0 .666-.3.666-.666 0-.367-.3-.667-.666-.667H9.333c-.366 0-.666.3-.666.667 0 .366.3.666.666.666zm-4 8A6.667 6.667 0 0012 20c1.22 0 2.361-.333 3.346-.907L6.24 9.987a6.624 6.624 0 00-.907 3.346z"
          id="stopwatchoff_solid_a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="stopwatchoff_solid_b" fill="#fff">
          <use xlinkHref="#stopwatchoff_solid_a" />
        </mask>
        <use fill="#FFF" fillRule="nonzero" xlinkHref="#stopwatchoff_solid_a" />
        <g
          mask="url(#stopwatchoff_solid_b)"
          fill={props.color || theme.palette.grey600}
        >
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
